/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PopupBaseComponent } from 'src/app/common/popup/popup-base.component';
import * as strings from '@touchplan/strings';

@Component({
	selector: 'paste-modes-info-popup',
	templateUrl: './paste-modes-info-popup.component.html',
	styleUrls: ['./paste-modes-info-popup.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasteModesInfoPopupComponent extends PopupBaseComponent {
	public appStrings = strings;
}
